export const PAGE_MODE = { SINGLE_PAGE: 'SINGLE_PAGE', MULTI_PAGE: 'MULTI_PAGE' } as const;
/**
 * number of pages to be shown before and after the currently selected page
 */
export const SINGLE_PAGE_VIEW_CONTEXT = 1;

export const SCALE_CONSTANTS = {
    MIN_SCALE: 0.25,
    MAX_SCALE: 5.0,
    DEFAULT_SCALE: 1.0,
    PREDEFINED_SCALES: [
        0.25, // 25%
        0.33, // 33%
        0.50, // 50%
        0.67, // 67%
        0.75, // 75%
        0.80, // 80%
        0.90, // 90%
        1.00, // 100%
        1.10, // 110%
        1.25, // 125%
        1.50, // 150%
        1.75, // 175%
        2.00, // 200%
        2.50, // 250%
        3.00, // 300%
        4.00, // 400%
        5.00  // 500%
    ]
} as const;
